module.exports = __webpack_public_path__ + "img/3.b8aef4b5.png";